import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import VisitCountManager from './components/VisitCountManager';

const Index = () => {
    const [totalVisits, setTotalVisits] = useState(0);

    useEffect(() => {
        const fetchVisits = async () => {
            const countManager = new VisitCountManager();
            setTotalVisits(await countManager.incTotalVisits());
        };

        fetchVisits();
    }, []);

    return <App totalVisits={totalVisits} />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Index />
);

reportWebVitals();